/* src/app/shared/services/dialog/auto-redeem-dialog/auto-redeem-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.auto-redeem-dialog {
  font-size: 1rem;
  padding: 1.8125em 1.625em;
  position: relative;
}
.auto-redeem-dialog .key-key {
  width: 72px;
  height: 4px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
}
.auto-redeem-dialog .close-button {
  position: absolute;
  top: 18px;
  right: 27px;
  background: none;
  outline: none;
}
.auto-redeem-dialog .close-button.cdk-focused.cdk-keyboard-focused {
  border: none;
  outline: none;
  background: none;
}
.auto-redeem-dialog .mat-mdc-dialog-title {
  font-size: 40px;
  font-weight: 400;
  line-height: 48px;
}
.auto-redeem-dialog .mat-mdc-dialog-title .title-span {
  font-weight: 700;
}
.auto-redeem-dialog .mat-mdc-dialog-title + .mat-mdc-dialog-content {
  margin-top: -2em;
}
.auto-redeem-dialog .mat-mdc-dialog-title.note-title {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #817b7b;
}
.auto-redeem-dialog .mat-mdc-dialog-content {
  padding: 2em 0 0 0;
  font-size: 20px;
  line-height: 1.5em;
}
.auto-redeem-dialog .mat-mdc-dialog-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin-top: 2.25em;
  margin-bottom: 0;
  padding: 0;
}
@media screen and (min-width: 48rem) {
  .auto-redeem-dialog .mat-mdc-dialog-actions {
    flex-direction: row;
  }
}
.auto-redeem-dialog .mat-mdc-dialog-actions button,
.auto-redeem-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button {
  width: 100%;
  margin: 0 0 0.5rem 0;
  padding: 12px 14px 12px 20px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
  border: none;
  border-radius: 22px;
  color: black;
  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 16px;
}
@media screen and (min-width: 48rem) {
  .auto-redeem-dialog .mat-mdc-dialog-actions button,
  .auto-redeem-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button {
    width: auto;
    margin: 0 1rem 0.5rem 0rem;
    padding: 10px 14px 10px 24px;
  }
}
.auto-redeem-dialog .mat-mdc-dialog-actions .alternative-button {
  background: white;
  padding: 12px 2px 12px 20px;
  border: 2px solid var(--ups-brand-colors-ups-blue, #0662BB);
  color: var(--ups-brand-colors-ups-blue, #0662BB);
  border-radius: 40px;
}
.auto-redeem-dialog.alternate .mat-mdc-dialog-content {
  overflow: visible;
}
.auto-redeem-dialog.alternate .mat-mdc-dialog-content .dialog-content {
  font-size: 1.5em;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
}
.auto-redeem-dialog.alternate .mat-mdc-dialog-actions {
  padding-bottom: 2rem;
  flex-direction: row-reverse;
}
.auto-redeem-dialog.alternate .mat-mdc-dialog-actions .mat-mdc-raised-button {
  height: 33px;
  font-size: 0.8em;
  line-height: 1;
}
/*# sourceMappingURL=auto-redeem-dialog.component.css.map */
